import React, { useState } from "react";
import { UpsellPanelSteps } from "../../../../constants/upsellPanelEnumsAndConstants";
import { isEurekaDomain, isIntelligentInvestorDomain, isInvestsmartDomain } from "../../../../utils/utils";
import Helpers from "../../../../constants/helpers";
import { useUpsellWidgetContainer } from "../../hooks/useUpsellWidgetContainerContext";
import { useUpsellWidgetModel } from "../../hooks/useUpsellWidgetModelContext";
import { UpsellLoader } from "./FormControls/UpsellLoader";

export const Step15PopupThankYou = () => {
  const { currentStep, goToStep, onCloseBtnClick, bgCssClass, baseProps } = useUpsellWidgetContainer();
  const model = useUpsellWidgetModel();

  if (currentStep !== UpsellPanelSteps.Step15PopupThankYou) {
    return null;
  }
  const [isClosing, setIsClosing] = useState(false);
  const isERDomain = isEurekaDomain();
  const isISDomain = isInvestsmartDomain();
  const isIIDomain = isIntelligentInvestorDomain();
  const hasDocument = !!model.downloadFileId;

  const handleCloseBtnClick = () => {
    onCloseBtnClick(true);
    setIsClosing(true);
  }

  return (
    <div className={`step15 ${bgCssClass}`}>
      {isClosing && <UpsellLoader />}
      {isISDomain ? (
        <div className="row mx-0">
          <div className="border-rad-8 offset-3-lg-up col-lg-6 px-4 pt-24 pb-32 bg-white shadow-hover border-rad-8-left border-rad-8-md-down d-flex">
            <img src={Helpers.getBlobFileUrl("/images/closing_x.svg")} className="popup-overlay close t-r hidden-md-down cursor-pointer"
              alt="Close popup window" onClick={handleCloseBtnClick}
            />
            <div className="d-flex align-self-center flex-column mt-64">
              <img src={Helpers.getBlobFileUrl("/images/email-inbox.svg")} alt="Check your inbox"
                className="mb-4 w-h-96 mx-auto"
              />
              <div className="font-circular-std-bold font-22 mb-32 t-c">
                Check your inbox
              </div>
              <ul className="font-16 t-l">
                <li className="mb-3">
                  Verify your email address by clicking on the link we sent to{" "}
                  <span className="font-circular-std-bold">{baseProps?.user?.email}</span>
                </li>
                <li>
                  You now have free access, we look forward to helping you on
                  your financial journey.
                </li>
              </ul>
              <div className="t-c mt-4">
                <button type="button" onClick={handleCloseBtnClick} className="btn btn-brand-style btn-primary font-19-no-line-height">
                  {hasDocument ? "Continue and download PDF" : "Continue"}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="row mx-0">
          <div
            className={`${isISDomain ? "border-rad-8 offset-3-lg-up" : "hidden-md-down"
              } col-lg-6 px-5 pt-40 pb-40 bg-white shadow-hover border-rad-8-left border-rad-8-md-down d-flex`}
          >
            <div className="d-flex align-self-center flex-column">
              <div className="font-22 pt-3 pb-2 font-circular-std-bold t-c">
                Congratulations!
              </div>
              <div
                className="font-19 text-color-gray-16 t-c"
                style={{ display: isISDomain ? "block" : "none" }}
              >
                You now have free access to Investsmart. We look forward to
                helping you on your financial journey.
              </div>
              <div className="font-19 text-color-gray-16 t-c"
                style={{ display: isERDomain ? "block" : "none" }}
              >
                You now have access to Free Eureka Report Insights. We look
                forward to helping you on your financial journey.
              </div>
              <div
                className="font-19 text-color-gray-16 t-c"
                style={{ display: isIIDomain ? "block" : "none" }}
              >
                You now have access to Intelligent Investor Free Insights. We
                look forward to helping you build a market-beating stock
                portfolio.
              </div>
              <div className="t-c mt-4">
                <button type="button" onClick={handleCloseBtnClick}
                  className="btn btn-brand-style btn-fw btn-primary font-19-no-line-height"
                >
                  {hasDocument ? "Continue and download PDF" : "Continue"}
                </button>
              </div>
            </div>
          </div>
          {/* Additional content for Intelligent Investor and Eureka */}
          {isIIDomain && (
            <div className="col-lg-6 col-12 pt-4 px-5 pb-40 bg-hold border-rad-8-right">
              <div className="font-17 text-color-gray-21 t-c border-bottom-1-light-white pb-2 mb-3">Looking for more…</div>
              <div className="font-25-sm-down-22 font-circular-std-bold t-c text-white">
                Intelligent Investor Membership
              </div>
              <div className="font-19 t-c font-circular-std-book pb-4 pt-2 link-primary">15-day Free Trial</div>
              <ul>
                <li className="font-17 py-3 text-white">Indepth analysis of ASX listed shares</li>
                <li className="font-17 py-3 text-white">BUY, Hold and Sell Recommendations</li>
                <li className="border-bottom-1-light-white font-17 py-3 text-white">Ideas Lab</li>
                <li className="font-17 py-3 text-white">Special Reports</li>
              </ul>
              <button type="button" onClick={() => goToStep(UpsellPanelSteps.Step4MobileUpdate)}
                className="btn btn-brand-style btn-fw btn-primary t-c mb-3 mt-4"
              >
                START YOUR TRIAL TODAY
              </button>
              <div className="t-c link-primary cursor-pointer font-17 text-underline" onClick={handleCloseBtnClick}>No thanks</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

